document.addEventListener('click', function (event) {
  const swatch = event.target.closest('[data-dm-card-swatch]');

  if (!swatch) return;

  event.preventDefault();
  event.stopPropagation();

  const cardWrapper = swatch.closest('.card-wrapper');

  if (!cardWrapper) return;

  const imageUrl = swatch.dataset.imageSrc;
  const imageAlt = swatch.dataset.imageAlt;
  const variantUrl = swatch.dataset.variantUrl;

  /*
   * Selected swatch
   */
  cardWrapper
    .querySelectorAll('[data-dm-card-swatch]')
    .forEach(function (item) {
      item.classList.remove('is-active');
      item.setAttribute('aria-pressed', 'false');
    });

  swatch.classList.add('is-active');
  swatch.setAttribute('aria-pressed', 'true');


  /*
   * Change the collection product image
   */
  const mainImage = cardWrapper.querySelector(
    '.card__media .media > img:first-child'
  );

  if (mainImage && imageUrl) {
    const preloadImage = new Image();

    preloadImage.addEventListener(
      'load',
      function () {
        /*
         * Dawn's original srcset would otherwise force the
         * old image to continue displaying.
         */
        mainImage.removeAttribute('srcset');

        mainImage.src = imageUrl;

        if (imageAlt) {
          mainImage.alt = imageAlt;
        }

        cardWrapper.classList.add('dm-variant-selected');
      },
      { once: true }
    );

    preloadImage.src = imageUrl;
  }


  /*
   * After selecting a color, clicking the product card/title
   * opens that exact variant.
   */
  if (variantUrl) {
    cardWrapper
      .querySelectorAll('a.full-unstyled-link')
      .forEach(function (link) {
        link.href = variantUrl;
      });
  }
});